export const termsSections = [
    {
        id: "1",
        icon: "📜",
        title: "ზოგადი დებულებები",
        subsections: [
            {
                id: "1.1",
                title: "წესებზე თანხმობა",
                content: [
                    `ვებსაიტის გამოყენება ავტომატურად ნიშნავს წესებზე სრულ თანხმობას.`,
                    `მომხმარებელი ადასტურებს, რომ გაეცნო მოცემულ პირობებს.`,
                    `თუ მომხმარებელი არ ეთანხმება პირობებს, მას არ აქვს უფლება გამოიყენოს პლატფორმა.`,
                    `პლატფორმის გამოყენება ნებისმიერი ფორმით ითვლება წესებზე თანხმობად.`,
                    `მომხმარებელი ვალდებულია პერიოდულად გადაამოწმოს წესები ცვლილებების შემთხვევაში.`
                ]
            },
            {
                id: "1.2",
                title: "პლატფორმის გამოყენება",
                content: [
                    `პლატფორმა წარმოადგენს მხოლოდ ტექნოლოგიურ გარემოს ინფორმაციის განთავსებისთვის.`,
                    `საიტი აკავშირებს რეპეტიტორებსა და მოსწავლეების მშობლებს.`,
                    `პლატფორმა არ წარმოადგენს საგანმანათლებლო დაწესებულებას და არ ახორციელებს სასწავლო პროცესს.`,
                    `პლატფორმა არ არის პასუხისმგებელი რეპეტიტორების მიერ გაწეულ მომსახურებაზე.`,
                    `ყველა ურთიერთობა მომხმარებლებს შორის ხდება მათი პირადი გადაწყვეტილებით.`
                ]
            },
            {
                id: "1.3",
                title: "ვებსაიტის ცვლილებები",
                content: [
                    `პლატფორმა იტოვებს უფლებას ნებისმიერ დროს შეცვალოს ან განაახლოს რეგულაციები, პირობები ან სხვა დოკუმენტები.`,
                    `მომხმარებელი ვალდებულია შეამოწმოს წესები რეგულარულად.`,
                    `საიტის გამოყენების გაგრძელება განიხილება, როგორც განახლებულ წესებზე თანხმობა.`,
                    `პლატფორმას აქვს უფლება ნებისმიერ დროს შეცვალოს ფუნქციები, დიზაინი ან მონაცემების წვდომა.`,
                    `პლატფორმის ცვლილებები არ ითვლება წინასწარ შეთანხმებულ მომსახურებად.`
                ]
            }
        ]
    },
    {
        id: "2",
        icon: "💳",
        title: "გადახდები",
        subsections: [
            {
                id: "2.1",
                title: "გადახდის პირობები",
                content: [
                    `რეპეტიტორის ანგარიშის აქტივაცია შეიძლება მოითხოვდეს გადახდას.`,
                    `გადახდა ხორციელდება მომხმარებლის ნებაყოფლობით.`,
                    `პლატფორმა არავის აიძულებს გადაიხადოს.`,
                    `გადახდის განხორციელებით მომხმარებელი ადასტურებს პირობებს და საკუთარ ფინანსურ პასუხისმგებლობას.`,
                    `გადახდის მეთოდები შეიძლება შეიცვალოს პლატფორმის მიერ.`
                ]
            },
            {
                id: "2.2",
                title: "თანხის არდაბრუნება",
                content: [
                    `ყველა გადახდა არის საბოლოო.`,
                    `გადახდილი თანხა არ ბრუნდება არავითარ შემთხვევაში.`,
                    `პლატფორმა არ იღებს პასუხისმგებლობას შეცდომით განხორციელებულ გადახდებზე.`,
                    `არასრულწლოვნების მიერ გადახდაზე პასუხისმგებელია მშობელი ან მეურვე.`,
                    `მომხმარებელი ადასტურებს, რომ გადახდა მისი ნებაყოფლობითი გადაწყვეტილებაა.`
                ]
            },
            {
                id: "2.3",
                title: "გადახდის მეთოდები",
                content: [
                    `პლატფორმა იყენებს საბანკო ფინანსური წარმომადგენლის მიერ მოწოდებულ გადახდის ელექტრონულ მეთოდს, რომელზეც წვდომა და გადახდის განხორციელება შეუძლია ნებისმიერი Mastercard (მასტერქარდი) ბარათის მფლობელს.`,
                    `გადახდის პროცესში არსებული ტექნიკური შეფერხებები არ არის პლატფორმის პასუხისმგებლობა.`,
                    `პლატფორმა არ იძლევა გარანტიას გადახდის მეთოდის უწყვეტობაზე ან ხელმისაწვდომობაზე.`,
                    `მომხმარებელმა უნდა გამოიყენოს მხოლოდ ნებადართული და კანონიერი მეთოდები.`,
                    `გადახდის შესრულების შემდეგ პლატფორმა უზრუნველყოფს ანგარიშის შესაბამის აქტივაციას.`
                ]
            }
        ]
    },
    {
        id: "3",
        icon: "👶",
        title: "არასრულწლოვნები",
        subsections: [
            {
                id: "3.1",
                title: "პასუხისმგებლობა მშობელზე",
                content: [
                    `თუ პლატფორმაზე გამოყენება ან გადახდა განხორციელდა არასრულწლოვანი პირის მიერ, პასუხისმგებლობა ეკისრება მის მშობელს, მეურვეს ან დროებით პასუხისმგებელ პირს.`,
                    `პლატფორმა არ არის პასუხისმგებელი არასრულწლოვნის ქმედებებზე.`,
                    `მშობელმა ან მეურვემ უნდა უზრუნველყოს არასრულწლოვნის ონლაინ აქტივობის კონტროლი.`,
                    `არასრულწლოვნის მიერ განხორციელებული ნებისმიერი ოპერაცია ითვლება მისი პასუხისმგებელი პირის მიერ ნებადართულად.`,
                    `პლატფორმა არ აბრუნებს თანხას არასრულწლოვნების გადახდის შემთხვევაში.`
                ]
            }
        ]
    },
    {
        id: "4",
        icon: "🎓",
        title: "რეპეტიტორები",
        subsections: [
            {
                id: "4.1",
                title: "რეგისტრაცია",
                content: [
                    `რეპეტიტორებს შეუძლიათ შექმნან ანგარიში პლატფორმაზე მათი მომსახურების წარმოსაჩენად.`,
                    `რეპეტიტორი ვალდებულია მიუთითოს რეალური ინფორმაცია.`,
                    `პლატფორმა არ იძლევა გარანტიას რეპეტიტორის სიზუსტეზე.`,
                    `მომხმარებელმა უნდა გადაამოწმოს ინფორმაცია დამოუკიდებლად.`,
                    `რეპეტიტორი პასუხისმგებელია საკუთარი პროფილის მართვაზე.`
                ]
            },
            {
                id: "4.2",
                title: "მომსახურების ხარისხი",
                content: [
                    `რეპეტიტორი დამოუკიდებლად მართავს თავის სერვისს.`,
                    `პლატფორმა არ არის პასუხისმგებელი რეპეტიტორის მიერ გაწეულ მომსახურებაზე.`,
                    `მომხმარებლებმა დამოუკიდებელად უნდა შეფასოს რეპეტიტორის მიერ მოწოდებული ინფორმაცია.`,
                    `რეპეტიტორი ვალდებულია არ აწარმოოს თაღლითური საქმიანობა.`,
                    `პლატფორმას აქვს უფლება შეზღუდოს ან წაშალოს ანგარიშები წარუმატებელი სერვისის შემთხვევაში.`
                ]
            }
        ]
    },
    {
        id: "5",
        icon: "⚖️",
        title: "პასუხისმგებლობის შეზღუდვა",
        subsections: [
            {
                id: "5.1",
                title: "თაღლითობა და ქმედებები",
                content: [
                    `პლატფორმა არ არის პასუხისმგებელი მომხმარებლების თაღლითობაზე.`,
                    `პლატფორმა არც აფინანსებს და არც არეგულირებს მომხმარებლებს შორის სავალდებულო გარიგებებს.`,
                    `მომხმარებელი ვალდებულია დამოუკიდებლად გადაამოწმოს სხვა მომხმარებლის ინფორმაცია.`,
                    `პლატფორმა არ არის პასუხისმგებელი გარიგების შედეგებზე.`,
                    `რეპეტიტორებისა და მშობლების მიერ გამოწვეული ნებისმიერი ზარალი ეკისრება მათ პირად პასუხისმგებლობას.`
                ]
            },
            {
                id: "5.2",
                title: "ტექნიკური პრობლემები",
                content: [
                    `პლატფორმა არ არის პასუხისმგებელი ჰოსტინგის პრობლემებზე, ინტერნეტზე, დენის გათიშვაზე ან მესამე მხარის სერვისებზე.`,
                    `გადახდების შეფერხებისას პლატფორმა არ არის პასუხისმგებელი პირი.`,
                    `მომხმარებელმა უნდა მიიღოს პასუხისმგებლობა ტექნიკურ შეზღუდვებზე.`,
                    `პლატფორმა არ იძლევა გარანტირიას საიტის უწყვეტ ფუნქციონირებაზე.`,
                    `მომხმარებელი იღებს ვალდებულებას არ დააყენოს პლატფორმა პასუხისმგებელ პირად ტექნიკურ შეფერხებებზე.`
                ]
            }
        ]
    },
    {
        id: "6",
        icon: "🎁",
        title: "დონაციები",
        subsections: [
            {
                id: "6.1",
                title: "დონაციის მიღება",
                content: [
                    `მომხმარებლებს შეუძლიათ ვებსაიტზე შეიტანონ დონაციები პლატფორმის მხარდაჭერისთვის.`,
                    `დონაციები სრულად ნებაყოფლობითია. პლატფორმა არავის აიძულებს დონაციას.`,
                    `დონაციების განხორციელება არ იძლევა დამატებით უფლებებს ან სერვისის გარანტიას.`,
                    `პლატფორმა აწარმოებს ტოპ 5 დონატორთა სიას მათ მიერ გადახდილი თანხისა და სურვილის შემთხვევაში სანახევროდ დაფარული ან ანონიმური სახელწოდების სახით.`,
                    `მომხმარებელი ადასტურებს, რომ დონაცია მისი ნებაყოფლობითი გადაწყვეტილებაა.`,
                    `პლატფორმას შეუძლია უარყოს ან შეზღუდოს დონაცია ნებისმიერი მიზეზით, მათ შორის ტექნიკური ან სამართლებრივი.`
                ]
            },
            {
                id: "6.2",
                title: "დონაციის პოლიტიკა",
                content: [
                    `დონაციების დაბრუნება არ ხორციელდება არცერთ შემთხვევაში.`,
                    `პლატფორმა არ არის პასუხისმგებელი არასრულწლოვნების მიერ განხორციელებულ დონაციებზე.`,
                    `მომხმარებელი ადასტურებს სრულ ფინანსურ პასუხისმგებლობას დონაციის განხორციელებაზე.`,
                    `პლატფორმას აქვს უფლება განახორციელოს დონაციების კონფიდენციალური აღრიცხვა.`,
                    `დონაციის მიღების შემდეგ პლატფორმა არ იძლევა სერვისის ან რაიმე დამატებითი შეღავათის გარანტიას.`
                ]
            }
        ]
    },
    {
        id: "7",
        icon: "📢",
        title: "რეკლამა და პარტნიორობა",
        subsections: [
            {
                id: "7.1",
                title: "სარეკლამო პერიოდი და განთავსება",
                content: [
                    `ყველა ტიპის სტანდარტული და პრიორიტეტული სარეკლამო განთავსება პლატფორმაზე მოქმედებს აქტივაციიდან 30 კალენდარული დღის განმავლობაში გარდა იმ შემთხვევისა თუ დამკვეთმა მოითხოვა განსხვავებული სერვისი, მაგალითად 45 დღე და შესათანხმებელი ფასი.`,
                    `იმ შემთხვევაში, თუ მოთხოვნა აჭარბებს კონკრეტულ სარეკლამო პოზიციაზე არსებულ თავისუფალ სივრცეს, სისტემა იყენებს როტაციისა და რანდომიზაციის პრინციპს სამართლიანი გადანაწილებისთვის.`,
                    `რეკლამა უნდა იყოს კანონიერი, ზუსტი და არ უნდა არღვევდეს მესამე პირების უფლებებს.`
                ]
            },
            {
                id: "7.2",
                title: "თანხის პროპორციული დაბრუნება (Refund)",
                content: [
                    `თუ თქვენ მიერ დაკავებული სარეკლამო პოზიცია სხვა დამკვეთის მიერ იქნა ჩანაცვლებული ვადაზე ადრე (მაგალითად, Level 3 მონოპოლიის ამოქმედებისას), პლატფორმა გარანტირებულად აგინაზღაურებთ მხოლოდ გამოუყენებელი დღეების შესაბამის პროპორციულ საფასურს.`,
                    `სარეკლამო პოლიტიკის თანახმად ანაზღაურება იანგარიშება მკაცრად პროპორციულად გამოუყენებელი სარეკლამო დღეების მიხედვით.`,
                ]
            },
            {
                id: "7.3",
                title: "პრიორიტეტული პაკეტები (Overpaid)",
                content: [
                    `Level 1 (პრიორიტეტული რანდომიზაცია) ზრდის რეკლამის ჩვენების პროცენტულ ალბათობას საერთო სარეკლამო ბადეში სხვა დამკვეთებთან შედარებით.`,
                    `Level 2 (100% ექსკლუზივი) იძლევა გარანტიას, რომ კონკრეტული სარეკლამო პოზიცია მუდმივად და ექსკლუზიურად დაეთმობა მხოლოდ ერთ ბრენდს.`,
                    `Level 3 (სრული მონოპოლია / Full Takeover) ითვალისწინებს საიტზე არსებული ყველა სხვა რეკლამის სრულ ბლოკირებას. მისი ღირებულება იანგარიშება ინდივიდუალურად, სადაც საბაზისო საფასურს ემატება იმ აქტიური კლიენტების გამოუყენებელი დღეების ნაშთი, რომელთა რეკლამაც უნდა ჩამოიხსნას.`
                ]
            }
        ]
    },
    {
        id: "8",
        icon: "🔒",
        title: "კონფიდენციალურობა",
        subsections: [
            {
                id: "8.1",
                title: "მომხმარებლის მონაცემები",
                content: [
                    `პლატფორმა იყენებს მომხმარებლის მიერ მოწოდებულ ინფორმაციას მხოლოდ მომსახურების მიწოდების, ანგარიშის მართვის და პლატფორმის ფუნქციონირების მიზნით.`,
                    `მომხმარებელს აქვს უფლება მოითხოვოს მონაცემების წაშლა ან განახლება.`,
                    `პლატფორმა იტოვებს უფლებას შეაგროვოს მონაცემები პლატფორმის უსაფრთხოების, ანალიზისა და გაუმჯობესების მიზნით.`,
                    `მომხმარებელი ადასტურებს, რომ მონაცემების მიწოდება ნებაყოფლობითია და კანონიერი.`,
                    `პლატფორმა არ იღებს პასუხისმგებლობას მონაცემების არასათანადო გამოყენებაზე მესამე მხარის მხრიდან.`
                ]
            },
            {
                id: "8.2",
                title: "კონფიდენციალურობის პოლიტიკა",
                content: [
                    `პლატფორმა დაიცავს მომხმარებლის პირად ინფორმაციას პლატფორმის არსებული ტექნიკური შესაძლებლობით.`,
                    `პლატფორმა არ უზრუნველყოფს კონფიდენციალურობის პარამეტრების თავისუფალ რეგულირებას მომხმარებლის მიერ.`,
                    `პლატფორმა არაა პასუხისმგებელი მესამე მხარის მიერ მოპოვებულ მონაცემებზე.`,
                    `მომხმარებელი ადასტურებს, რომ მონაცემების მიწოდება პლატფორმისთვის არის უსაფრთხო და ნებაყოფლობითი.`,
                    `პლატფორმას აქვს უფლება განახორციელოს მონაცემების ანალიზი ან ანონიმიზაცია სერვისის გაუმჯობესების მიზნით.`
                ]
            }
        ]
    },
    {
        id: "9",
        icon: "🚫",
        title: "ანგარიშის მართვა",
        subsections: [
            {
                id: "9.1",
                title: "ანგარიშის შეზღუდვა",
                content: [
                    `პლატფორმას აქვს უფლება შეზღუდოს მომხმარებლის ანგარიშის წვდომა წესების დარღვევის ან სუსტი სერვისის შემთხვევებში.`,
                    `შეზღუდვა შეიძლება მოიცავდეს დროებით შეზღუდვას ან გარკვეული ფუნქციის დეაქტივაციას.`,
                    `მომხმარებელს არ ეძლევა შეტყობინება შეზღუდვის მიზეზზე.`,
                    `პლატფორმა არ არის პასუხისმგებელი შეზღუდვის შედეგად მიღებულ ზარალზე.`,
                    `მომხმარებელი იღებს ვალდებულებას, რომ დაიცვას შეზღუდვების პირობები.`
                ]
            },
            {
                id: "9.2",
                title: "ანგარიშის წაშლა",
                content: [
                    `მომხმარებელს შეუძლია მოითხოვოს თავისი ანგარიშის წაშლა პლატფორმიდან.`,
                    `პლატფორმას აქვს უფლება წაშალოს ანგარიშები წესების დარღვევის ან კანონიერი მიზეზების შემთხვევაში.`,
                    `ანგარიშის წაშლა სრულად აუქმებს პლატფორმაზე მომხმარებლის აქტივობას და მონაცემებს.`,
                    `პლატფორმა არ არის პასუხისმგებელი წაშლილი ანგარიშიდან მიღებულ შედეგებზე.`,
                    `მომხმარებელი ადასტურებს, რომ წაშლის პროცესში დაკარგული ინფორმაცია არ იბრუნება.`,
                    `დაბლოკილი ანგარიშები აღდგენას/წაშლას არ ექვემდებარება.`
                ]
            }
        ]
    },
    {
        id: "10",
        icon: "⚙️",
        title: "ცვლილებები",
        subsections: [
            {
                id: "10.1",
                title: "სერვისის ცვლილებები",
                content: [
                    `პლატფორმა იტოვებს უფლებას შეცვალოს ან განაახლოს სერვისები, დიზაინი, ფუნქციონალი ან პლატფორმის ნებართვები.`,
                    `ცვლილებები არ ითვლება წინასწარ შეთანხმებულ სერვისად.`,
                    `მომხმარებელს ეძლევა ვალდებულება შეეგუოს ნებისმიერ ცვლილებას პლატფორმის გამოყენებისას.`,
                    `პლატფორმა არ არის პასუხისმგებელი ცვლილებების შედეგად მიღებულ სარგებლობაზე ან ზარალზე.`,
                ]
            },
            {
                id: "10.2",
                title: "სისტემური შეზღუდვები",
                content: [
                    `პლატფორმა არ არის პასუხისმგებელი ჰოსტინგის, ინტერნეტის ან მესამე მხარის სერვისის შეფერხებებზე.`,
                    `ტექნიკური პრობლემები არ აძლევს მომხმარებელს უფლებას განიხილოს პლატფორმის პასუხისმგებლობა.`,
                    `მომხმარებელი ადასტურებს, რომ სისტემური შეზღუდვები არის ნორმალური და მისთვის ცნობილი რისკია.`,
                    `პლატფორმას შეუძლია დროებით შეზღუდოს სერვისი ტექნიკური ან სამართლებრივი მიზეზების გამო.`,
                    `პლატფორმა არ არის ვალდებული კომპენსაციით ან თანხის დაბრუნებით.`
                ]
            }
        ]
    },
    {
        id: "11",
        icon: "🛡️",
        title: "უსაფრთხოება",
        subsections: [
            {
                id: "11.1",
                title: "პლატფორმის დაცვა",
                content: [
                    `პლატფორმა იღებს ტექნიკურ ზომებს მომხმარებლის მონაცემების დაცვისა და სისტემის უსაფრთხოების უზრუნველსაყოფად.`,
                    `მომხმარებელი ვალდებულია გამოიყენოს ძლიერი პაროლები და დაიცვას საკუთარი ანგარიშის კონფიდენციალურობა.`,
                    `პლატფორმა არ არის პასუხისმგებელი მომხმარებლის მიერ უსაფრთხოების ზომების უგულებელყოფაზე.`,
                    `ყველა მომხმარებელი თანხმდება დაუყოვნებლივ აცნობოს პლატფორმას ნებისმიერ უსაფრთხოების დარღვევაზე.`,
                ]
            },
            {
                id: "11.2",
                title: "მომხმარებლის ვალდებულებები",
                content: [
                    `მომხმარებელი ვალდებულია არ გაუზიაროს ანგარიში, პაროლი ან სენსიტიური ინფორმაცია მესამე პირებს.`,
                    `მომხმარებელი პასუხისმგებელია ანგარიშის ნებისმიერი ქმედებისათვის, მიუხედავად იმისა ვინ იყენებს ანგარიშს.`,
                    `პლატფორმას აქვს უფლება დროებით დაბლოკოს ანგარიში უსაფრთხოების დარღვევის შემთხვევაში.`,
                    `მომხმარებელი ადასტურებს, რომ პლატფორმა არ არის პასუხისმგებელი უსაფრთხოების უხარისხოდ დაცვაზე მისი მხრიდან.`,
                ]
            }
        ]
    },
    {
        id: "12",
        icon: "⏸️",
        title: "შეზღუდვები",
        subsections: [
            {
                id: "12.1",
                title: "დროებითი შეზღუდვა",
                content: [
                    `პლატფორმას შეუძლია დროებით შეზღუდოს სერვისი ტექნიკური ან სამართლებრივი მიზეზების გამო.`,
                    `შეზღუდვა შეიძლება მოიცავდეს ანგარიშის წვდომის შეზღუდვას ან პლატფორმის კონკრეტული ფუნქციის დეაქტივაციას.`,
                    `მომხმარებელი ადასტურებს, რომ შეზღუდვა არ ქმნის უფლებას კომპენსაციის ან თანხის დაბრუნებაზე.`,
                    `პლატფორმა არ არის პასუხისმგებელი შეზღუდვის შედეგად წარმოშობილ რაიმე ზარალზე.`,
                    `მომხმარებელი ვალდებულია შეეგუოს დროებით შეზღუდვებს პლატფორმის გამოყენებისას.`
                ]
            },
            {
                id: "12.2",
                title: "მომსახურების შეწყვეტა",
                content: [
                    `პლატფორმას შეუძლია დროებით ან მუდმივად შეწყვიტოს გარკვეული სერვისები.`,
                    `პლატფორმის ნებისმიერი სერვისის შეწყვეტა არის პლატფორმის ადმინისტრაციული უფლება.`,
                    `პლატფორმა შეეცდება მომხმარებელს წინასწარ აცნობოს მნიშვნელოვანი შეწყვეტის შესახებ, მაგრამ არა ვალდებულებით.`,
                ]
            }
        ]
    },
    {
        id: "13",
        icon: "⚠️",
        title: "დარღვევები",
        subsections: [
            {
                id: "13.1",
                title: "აკრძალული ქმედებები",
                content: [
                    `მომხმარებელს ეკრძალება პლატფორმის გამოყენება უკანონო, თაღლითური ან საზიანო საქმიანობისთვის.`,
                    `რეპეტიტორებს ეკრძალებათ თავიანთი სერვისის გაყიდვა პლატფორმის წესების დარღვევით.`,
                    `მომხმარებელმა უნდა უზრუნველყოს, რომ მის მიერ გამოქვეყნებული ინფორმაცია არ ზღუდავს მესამე პირის უფლებებს.`,
                    `პლატფორმას აქვს უფლება დროებით ან მუდმივად დაბლოკოს ანგარიშები დარღვევის შემთხვევაში.`,
                ]
            },
            {
                id: "13.2",
                title: "პასუხისმგებლობა",
                content: [
                    `მომხმარებელი პასუხისმგებელია ნებისმიერი იურიდიული შედეგისთვის, რომელიც წარმოიშობა პლატფორმის წესების დარღვევით.`,
                    `პლატფორმა არ იღებს პასუხისმგებლობას მომხმარებლის მიერ განხორციელებულ უკანონო ქმედებებზე.`,
                    `პლატფორმა იტოვებს უფლებას გამოაცხადოს წესების დარღვევა და დროებით შეზღუდოს მომხმარებელი.`,
                    `დარღვევა მოიცავს ყველა ფინანსურ, სამართლებრივ და ტექნიკურ შედეგს.`,
                    `მომხმარებელი ადასტურებს, რომ პლატფორმის შეზღუდვა ან წაშლა არ ითვლება ზიანის ანაზღაურებად.`,
                    `პლატფორმა იტოვებს უფლებას საჯაროდ გამოაჩინოს დამრღვევი მომხმარებლის ვინაობა.`
                ]
            }
        ]
    },
    {
        id: "14",
        icon: "🤝",
        title: "დავების გადაწყვეტა",
        subsections: [
            {
                id: "14.1",
                title: "შეთანხმება",
                content: [
                    `ყველა მომხმარებელი თანხმდება, რომ ნებისმიერი დავა, რომელიც წარმოიშობა პლატფორმის გამოყენებისას, ძირითადად გადაწყვეტილი იქნება მოლაპარაკების გზით.`,
                    `თუ მოლაპარაკება არ არის შესაძლებელი, დავა გადაეცემა პლატფორმის იურიდიულ წარმომადგენელს.`,
                    `მომხმარებელი ადასტურებს, რომ არცერთი დავა არ ითვალისწინებს კომპენსაციას პლატფორმისგან.`,
                    `დავების გადაწყვეტის პროცესში პლატფორმა მოქმედებს მხოლოდ წესების შესაბამისად.`,
                ]
            },
            {
                id: "14.2",
                title: "ფინანსური დავები",
                content: [
                    `ფინანსური დავები უნდა გადაწყდეს დამოუკიდებლად მომხმარებელსა და მეორე მხარეს შორის.`,
                    `პლატფორმა არ არის პასუხისმგებელი თანხის დაბრუნებაზე ან ზიანის ანაზღაურებაზე.`,
                    `ფინანსური დავების შემთხვევაში პლატფორმა მხოლოდ უზრუნველყოფს ტექნიკურ მხარდაჭერას.`,
                    `მომხმარებელი ადასტურებს, რომ პლატფორმის როლი არის მხოლოდ შუამავალი.`,
                ]
            }
        ]
    },
    {
        id: "15",
        icon: "✨",
        title: "დამატებითი წესები",
        subsections: [
            {
                id: "15.1",
                title: "სხვა პირობები",
                content: [
                    `პლატფორმა იტოვებს უფლებას განახორციელოს დამატებითი რეგულაციები ნებისმიერ დროს.`,
                    `მომხმარებელს ევალება განახლებების დაცვა პლატფორმის გამოყენებისას.`,
                    `დამატებითი წესები არ ცვლიან წინასწარ მიღებულ წესებს, გარდა სპეციალური შემთხვევებისა.`,
                    `პლატფორმა არ არის პასუხისმგებელი ცვლილებების შედეგად მიღებულ შედეგებზე.`,
                    `მომხმარებელი ადასტურებს, რომ სრულად ეთანხმება დამატებით რეგულაციებს.`
                ]
            },
            {
                id: "15.2",
                title: "სუბიექტების რეგულაციები",
                content: [
                    `პირებს, რომლებიც იყენებენ პლატფორმას რეკლამისთვის, ეკისრებათ სრული პასუხისმგებლობა თავიანთ ქმედებებზე.`,
                    `პლატფორმა არ არის პასუხისმგებელი რეკლამის შინაარსზე ან სერვისის შედეგებზე.`,
                    `წესების დარღვევა იწვევს ანგარიშის შეზღუდვას ან წაშლას.`,
                    `მომხმარებელი ადასტურებს, რომ პლატფორმა არ არის პასუხისმგებელი მესამე მხარის შედეგებისთვის.`,
                    `ყველა პირი თანხმდება დაიცვას პლატფორმის წესები და პირობები.`
                ]
            }
        ]
    }
];